module.exports = __webpack_public_path__ + "img/beijing.769c26bf.png";